<template>
  <transition name="page-loader">
    <div v-show="active" class="page-loader">
      <div class="page-loader-content">
        <div class="page-loader-logo">
          <slot name="logo"></slot>
        </div>

        <div class="page-loader-text">
          <slot name="text">
            <p>{{ text }}</p>
          </slot>
        </div>

        <div v-if="progress" class="page-loader-bar">
          <span :style="{ width: progress + '%' }"></span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { inject } from 'vue';
const { active, text, progress } = inject('$pageLoader');

</script>

<style lang="scss">
.page-loader {
  z-index: 9999999;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;

  .page-loader-content {
    text-align: center;
  }

  .page-loader-logo {
    max-width: 100%;
    width: 300px;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  .page-loader-text {
    color: #fff;
  }

  .page-loader-bar {
    margin-top: 20px;
    width: 500px;
    height: 20px;
    position: relative;
    background-color: #fff;
    border: 4px solid #fff;
    border-radius: 20px;
    overflow: hidden;

    span {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      background-color: #008000;
    }

  }
}

///////////////////////////////////////////////////////// Transition
.page-loader-enter-active,
.page-loader-leave-active {
  transition: opacity 250ms ease-out;
}

.page-loader-enter-from,
.page-loader-leave-to {
  opacity: 0;
}
</style>